export class Cookie {
    domain: string =  `.${document.domain}`;
    path:string =  "/";
    maxAge: number =  60 * 60 * 24 * 365;
  
}


// WEBPACK FOOTER //
// ./src/app/components/app/class/cookie.ts